/**
 * WordPress dependencies
 */
import { createHooks } from '@wordpress/hooks';

export default createHooks();
